import {
  Avatar,
  BasketFillIcon,
  Box,
  ErrorfilledIcon,
  Grid2,
  Show,
  Typography,
} from "components";
import { useFormContext } from "react-hook-form";
import { WebsiteDetails } from "./types";
import { map } from "lodash";

const BasketForm = () => {
  const form = useFormContext<WebsiteDetails>();

  return (
    <Grid2 container spacing={1}>
      <Show.When
        isTrue={form.getValues("websiteSection.myBaskets").length === 0}
      >
        <Grid2 border={"1px solid var(--neutral-100)"} borderRadius={3} p={3}>
          <Grid2 size={12} display={"flex"} justifyContent={"center"}>
            <ErrorfilledIcon color="var(--yellow-700)" width={40} height={40} />
          </Grid2>
          <Grid2 size={12} display={"flex"} justifyContent={"center"}>
            <Typography fontSize={16} fontWeight={700} color="var(--black-900)">
              Preview content only
            </Typography>
          </Grid2>
          <Grid2 size={12}>
            <Typography
              display={"flex"}
              textAlign={"center"}
              color="var(--neutral-500)"
              fontSize={12}
              fontWeight={500}
            >
              The Basket shown here is for preview purposes only. Once you
              create your own Basket, it will appear in this section.
            </Typography>
          </Grid2>
        </Grid2>
      </Show.When>

      <Show.When
        isTrue={form.getValues("websiteSection.myBaskets").length !== 0}
      >
        <Grid2 container spacing={2}>
          {map(form.getValues("websiteSection.myBaskets"), (basket) => (
            <Grid2
              key={basket.id}
              size={12}
              container
              border={"1px solid var(--neutral-100)"}
              borderRadius={3}
              p={1.5}
              spacing={1.5}
            >
              <Grid2
                size={"auto"}
                display={"flex"}
                alignItems="center"
                gap={0.75}
                borderRadius={"8px 8px 8px 0"}
                p={1}
                bgcolor={"var(--neutral-50)"}
              >
                <BasketFillIcon />
                <Typography
                  fontSize={12}
                  fontWeight={500}
                  color="var(--neutral-700)"
                >
                  {basket?.basketType === "Model"
                    ? "Model Portfolio"
                    : "Stock Recommendation"}
                </Typography>
              </Grid2>

              <Grid2 size={12} display={"flex"} alignItems={"center"} gap={2}>
                <Avatar
                  alt=""
                  src={basket?.basketLogo || "/Logos/errorImg.svg"}
                  sx={{
                    width: "56px",
                    height: "56px",
                    flexShrink: 0,
                    aspectRatio: "1 / 1",
                    border: "1px solid var(--neutral-100)",
                    borderRadius: 1,
                  }}
                />

                <Box
                  textOverflow={"ellipsis"}
                  whiteSpace={"nowrap"}
                  overflow={"hidden"}
                >
                  <Typography
                    fontSize={16}
                    fontWeight={600}
                    color="var(--black)"
                  >
                    {basket?.name}
                  </Typography>
                  <Typography
                    fontSize={12}
                    fontWeight={500}
                    color="var(--neutral-500)"
                    dangerouslySetInnerHTML={{ __html: basket?.overview }}
                  />
                </Box>
              </Grid2>
            </Grid2>
          ))}
        </Grid2>
      </Show.When>
    </Grid2>
  );
};

export default BasketForm;
